import stepperReducer from "./fileUploadReducer";

const reducers = {
  fileUpload: stepperReducer
};

export default reducers;
